import { html, TemplateResult } from 'lit'
import type { ProductSpecificationItem } from 'components/discovery/pdp/product-specifications/typing/product-specifications.js'


const formatValue = (item: ProductSpecificationItem): string =>
  item.uom ? `${item.value} ${item.uom}` : item.value

export function renderTextLayout(items: ProductSpecificationItem[]): TemplateResult {
  return html`<cse-text>${items.map(formatValue).join(', ')}</cse-text>`
}
